;
define("store_locator_map.tpl", function(){});

